import { AiOutlineUser } from "react-icons/ai";
import { shortenString } from "@lib/helpers/StringHelper";
import { Tag } from "antd";
import IntlMessages from "@lib/helpers/IntlMessages";
import TableIdButton from "@lib/components/MiniComponents/Buttons/TableIdButton";
import { green, red } from "@ant-design/colors";
import { TiInfoLarge } from "react-icons/ti";
import { CoinPriceTextFormat } from "@lib/components/MiniComponents/Others";
import { AppListItemMetaProps } from "@lib/components/AppComponents/AppListNew";
import { AllCurrencies, TransactionType } from "@lib/types";
import { randomColor } from "@lib/helpers/ColorHelper";
import { AppTag } from "@lib/components/AppComponents";

export const SidebarPaymentProviderDetailListItems = ({
  provider,
  isLoading,
}) => {
  if (isLoading) return [];
  return [
    {
      title: provider?.name,
      avatar: <AiOutlineUser />,
    },
    {
      avatar: <>ID</>,
      title: (
        <TableIdButton
          text={`#${shortenString(provider.id, 22)}`}
          textToBeCopied={provider.id}
        />
      ),
    },
    {
      avatar: <TiInfoLarge />,
      title: (
        <Tag color={provider?.enabled ? green[7] : red[7]}>
          <IntlMessages
            id={provider?.enabled ? "common.enabled" : "common.disabled"}
          />
        </Tag>
      ),
    },
  ] as AppListItemMetaProps[];
};

type SidebarPaymentSummaryListItemsType = {
  blockchainTransactionsData: TransactionType[];
  isLoading: boolean;
};

type ListItem = { amount: number; currency: AllCurrencies };

export const SidebarPaymentSummaryListItems = ({
  blockchainTransactionsData,
  isLoading,
}: SidebarPaymentSummaryListItemsType) => {
  const amounts = () => {
    const obj: ListItem[] = [];
    for (let index = 0; index < blockchainTransactionsData?.length; index++) {
      const findIndex = obj.findIndex(
        (f) => f.currency == blockchainTransactionsData[index].currency,
      );
      if (findIndex !== -1) {
        obj[findIndex].amount += Number(
          blockchainTransactionsData[index].amount,
        );
      } else {
        obj.push({
          amount: Number(blockchainTransactionsData[index].amount),
          currency: blockchainTransactionsData[index].currency,
        });
      }
    }
    return obj;
  };

  if (isLoading) return [];

  return (
    (amounts()?.map((item, index) => ({
      avatar: `${item.currency}: `,
      title: (
        <AppTag color={randomColor(index)}>
          <CoinPriceTextFormat
            amount={item.amount}
            currency={item.currency}
            showCurrency={item.currency}
            showCurrencyImage
          />
        </AppTag>
      ),
    })) as AppListItemMetaProps[]) || []
  );
};
